export default __webpack_public_path__ + "static/media/single-line-blackboard-low.deff50a1.jpg";